
import { RevButton } from '@backmarket/design-system'

import translations from './DeviceQuestions.translations'
import Question from './Question.vue'

export default {
  components: {
    Question,
    RevButton,
  },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    questionAppearance: {
      type: String,
      required: true,
    },
    scrollEffect: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showSubmit: false,
    }
  },
  computed: {
    translations: () => translations,
  },
  watch: {
    async showSubmit() {
      if (this.showSubmit !== false) {
        await this.$nextTick()

        this.$refs.submit.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        })
      }
    },
  },
  methods: {
    handleCompleted({ last, key, value }) {
      this.showSubmit = last
      this.$emit('answered', { key, value })
    },
    handleSubmit() {
      this.$emit('submit', { to: 'confirmation' })
    },
  },
}
